import moment from 'moment'
import React from 'react'
import { FaStore, FaStoreAltSlash } from 'react-icons/fa'

const InvoiceTransactionsList = ({ invoiceTransactions }) => {
  return (
    <div className="summay-invoice-card">
      <div className="summary-header">
        <h2 className="section-title">Transações</h2>
      </div>

      <div className="transaction-list">
        {
          !invoiceTransactions.length ? (
            <div className="transaction-item">
              <div className="transaction-details">
                <div className="transaction-icon">
                  <FaStoreAltSlash size={20} />
                </div>
                <div className="transaction-info">
                  <div className="transaction-name">Ainda não houve transações</div>
                </div>
              </div>
            </div>
          )
            :
            invoiceTransactions.map((invoiceTansaction, index) => (
              <div className="transaction-item" key={index}>
                <div className="transaction-details">
                  <div className="transaction-icon">
                    <FaStore size={20} />
                  </div>
                  <div className="transaction-info">
                    <div className="transaction-name">{invoiceTansaction.transaction.establishmentName || 'Sem descrição'}</div>
                    <div className="transaction-date">{moment(invoiceTansaction.transaction.date).format('DD/MM/YYYY')}</div>
                  </div>
                </div>
                <div className="transaction-amount negative">{Number(invoiceTansaction.transaction.amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
              </div>
            ))
        }
      </div>
    </div>
  )
}

export default InvoiceTransactionsList
